import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import { ContactUsModal } from '../../sideMenu/contactUs/ContactUsModal';
import { SupportButton } from '../../common/SupportButton';
import { BackButton } from './BackButton';
import { CONTACT_US_STEPS } from '../../sideMenu/contactUs/contactUs.constants';
import { CERTIFICATE_LINKING_STEPS } from '../petDemographics.constants';

import * as routes from '../../navigation/routes.constants';

import { ReactComponent as PawIcon } from
  '../../../assets/sideMenu/petcloud-paw.svg';
import { ReactComponent as PetCloudIcon } from
  '../../../assets/sideMenu/petcloud-text.svg';

import styles from './BaseLayout.module.css';
import { LANGUAGES_FR_CA } from '../../../i18n';

const DO_NOT_SELL_REF = '#';

const BaseLayout = ({
  children,
  currentStep = CERTIFICATE_LINKING_STEPS.LANDING,
  handleGoBack = () => { },
}) => {
  const { t } = useTranslation('petDemos');

  const privacyLink = useMemo(
    () => (i18next.language === LANGUAGES_FR_CA
      ? routes.VIE_PRIVEE : routes.PRIVACY_POLICY),
    [i18next.language],
  );

  const [isOpen, setIsOpen] = useState(false);

  function handleOnClickSupport() {
    setIsOpen(true);
  }

  function handleCloseModal() {
    setIsOpen(false);
  }

  function handleDoNotSellClick(event) {
    event.preventDefault();
    window.Osano?.cm?.showDoNotSell();
  }

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <BackButton
            currentStep={currentStep}
            handleGoBack={handleGoBack}
          />

          <div className={styles.iconContainer}>
            <PawIcon className={styles.pawIcon} />

            <PetCloudIcon className={styles.petCloudIcon} />
          </div>
        </header>

        <section className={styles.content}>
          {children}
        </section>
      </div>

      <footer className={styles.footer}>
        <div className={styles.supportContainer}>
          <SupportButton
            label={t('certificateLinking.common.needSupport')}
            onClick={handleOnClickSupport}
          />
        </div>

        <div className={styles.bottomContainer}>
          <div className={styles.linksContainer}>
            <a
              className={styles.footerLink}
              href={privacyLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              {t('certificateLinking.common.privacyPolicy')}
            </a>

            <a
              className={styles.footerLink}
              href={routes.TERMS_OF_USE}
              rel="noopener noreferrer"
              target="_blank"
            >
              {t('certificateLinking.common.termsOfUse')}
            </a>

            <a
              className={styles.footerLink}
              href={DO_NOT_SELL_REF}
              onClick={handleDoNotSellClick}
              rel="noopener noreferrer"
              target="_blank"
            >
              {t('certificateLinking.common.doNotSell')}
            </a>
          </div>

          <span className={styles.copyright}>
            {t('certificateLinking.common.copyright')}
          </span>
        </div>
      </footer>

      <ContactUsModal
        companyStep={CONTACT_US_STEPS.PPI_ONE_PACK}
        onClose={handleCloseModal}
        show={isOpen}
      />
    </div>
  );
};

export { BaseLayout };
